<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import BlueskyMixin from '@/share/campaign/bluesky-mixin'

export default {
  components: { ButtonBase },

  mixins: [BlueskyMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
